import { createApiUrl } from '../../../Config/apiConfig';

export const API_ENDPOINTS = {
    GAME_INFO: createApiUrl('GameInfo'),
    REGULATED_MARKET: createApiUrl('RegulatedMarket'),
    LOBBY: createApiUrl('Lobby'),
    GAMEFLEX_INFO: createApiUrl('CoreflexData/fetch-games'),
    AUTHENTICATE: createApiUrl('authenticate/authenticate'),
    OPERATORS: createApiUrl('authenticate/operators'),
    BRANDS: createApiUrl('authenticate/brands')
};

export const PLATFORM_KEY_OPTIONS = [
    { key: 'P009', url: 'https://gameflex-p000.iforium.com/gamelaunch' },
    { key: 'L020', url: 'https://gameflex-l020.game-flex.us/gamelaunch' },
    { key: 'L022', url: 'https://gameflex-l022.game-flex.us/gamelaunch' },
    { key: 'L023', url: 'https://gameflex-l023.game-flex.us/gamelaunch' },
    { key: 'L024', url: 'https://gameflex-l024.game-flex.us/gamelaunch' },
    { key: 'L025', url: 'https://gameflex-l025.game-flex.us/gamelaunch' },
];

export const MARKET_SITE_MAPPING = {
    'New Jersey': [{ name: 'NJS' }, { name: 'NJP' }],
    'Michigan': [{ name: 'MIS' }, { name: 'MIP' }],
    'Pennsylvania': [{ name: 'PAS' }, { name: 'PAP' }],
    'Ontario': [{ name: 'ONS' }, { name: 'ONP' }],
    'Connecticut': [{ name: 'CTS' }, { name: 'CTP' }]
};

export const DEFAULT_STATE = {
    game: null,
    market: null,
    site: null,
    language: { name: 'English' },
    serverId: '',
    lobby: '',
    productName: '',
    token: '',
    currency: { name: 'USD' },
    platformKey: null,
    rootUrl: '',
    username: '',
    password: '',
    operatorCode: null,
    brand: null,
    mobDesk: "Desktop",
    accountId: '',
    authToken: ''
};

export const DEFAULT_LANGUAGES = [
    { name: 'English' },
    { name: 'Spanish' },
    { name: 'French' },
];